var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "info", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("caneAudio.introTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("caneAudio.introBody"))),
          ]),
        ]
      ),
      _c(
        "el-row",
        { staticClass: "special-row", attrs: { gutter: 12 } },
        _vm._l(_vm.specialCards, function (card) {
          return _c(
            "el-col",
            { key: card.kind, attrs: { span: 12 } },
            [
              _c(
                "el-card",
                { staticClass: "special-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.$t("caneAudio.kind_" + card.kind))),
                      ]),
                      _c(
                        "span",
                        { staticClass: "card-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.openVersions(card.kind, null, null)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("caneAudio.versions")) +
                                  " (" +
                                  _vm._s(card.data.versionCount) +
                                  ") "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-upload2",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openUpload(card.kind, null, null)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("caneAudio.uploadVersion")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  card.data.activePack
                    ? _c(
                        "div",
                        { staticClass: "pack-line" },
                        [
                          _c(
                            "el-tag",
                            { attrs: { size: "small", type: "success" } },
                            [_vm._v(_vm._s(card.data.activePack.version))]
                          ),
                          _c("span", { staticClass: "sub" }, [
                            _vm._v(
                              _vm._s(_vm.fmtSize(card.data.activePack.size))
                            ),
                          ]),
                          _c("span", { staticClass: "sub mono" }, [
                            _vm._v(
                              _vm._s(_vm.shortSha(card.data.activePack.sha256))
                            ),
                          ]),
                          _c(
                            "a",
                            {
                              staticClass: "sub",
                              attrs: {
                                href: card.data.activePack.url,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("caneAudio.download")))]
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "sub warn" }, [
                        _vm._v(_vm._s(_vm.$t("caneAudio.noActivePack"))),
                      ]),
                  _c("div", { staticClass: "sub" }, [
                    _vm._v(_vm._s(_vm.$t("caneAudio.kindHint_" + card.kind))),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "260px" },
            attrs: {
              placeholder: _vm.$t("caneAudio.searchPlaceholder"),
              clearable: "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _c(
            "el-checkbox",
            {
              staticClass: "filter-item",
              model: {
                value: _vm.showInactive,
                callback: function ($$v) {
                  _vm.showInactive = $$v
                },
                expression: "showInactive",
              },
            },
            [_vm._v(_vm._s(_vm.$t("caneAudio.showInactive")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh", loading: _vm.loading },
              on: { click: _vm.fetch },
            },
            [_vm._v(" " + _vm._s(_vm.$t("caneAudio.refresh")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.openCreateLanguage },
            },
            [_vm._v(" " + _vm._s(_vm.$t("caneAudio.newLanguage")) + " ")]
          ),
          _c("span", { staticClass: "sub count" }, [
            _vm._v(
              _vm._s(
                _vm.$t("caneAudio.languageCount", {
                  n: _vm.visibleLanguages.length,
                })
              )
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.visibleLanguages,
            border: "",
            fit: "",
            size: "small",
            "row-class-name": _vm.rowClass,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t("caneAudio.code"), width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "mono" }, [
                      _vm._v(_vm._s(row.code)),
                    ]),
                    row.backendKey !== row.code
                      ? _c("div", { staticClass: "sub mono" }, [
                          _vm._v(
                            _vm._s(_vm.$t("caneAudio.backendKey")) +
                              ": " +
                              _vm._s(row.backendKey)
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("caneAudio.displayName"),
              "min-width": "190",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(row.displayName) + " "),
                    _c("div", { staticClass: "sub" }, [
                      _c("span", { staticClass: "mono" }, [
                        _vm._v(_vm._s(row.otaFolder) + "/"),
                      ]),
                      row.aliases.length
                        ? _c("span", [
                            _vm._v(
                              " · " +
                                _vm._s(_vm.$t("caneAudio.aliases")) +
                                ": " +
                                _vm._s(row.aliases.join(", "))
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.slotOrder, function (slot) {
            return _c("el-table-column", {
              key: slot,
              attrs: {
                label: _vm.$t("caneAudio.slot_" + slot),
                "min-width": "150",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm.slotView(row, slot)
                          ? _c(
                              "div",
                              [
                                _vm.slotView(row, slot).activePack
                                  ? [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.slotView(row, slot).activePack
                                                .version
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("span", { staticClass: "sub" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.fmtSize(
                                              _vm.slotView(row, slot).activePack
                                                .size
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  : _vm.slotView(row, slot).ttsVoiceName
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "warning",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("caneAudio.noPack"))
                                        ),
                                      ]
                                    )
                                  : _c("span", { staticClass: "sub" }, [
                                      _vm._v("—"),
                                    ]),
                                _vm.slotView(row, slot).ttsVoiceName
                                  ? _c(
                                      "div",
                                      { staticClass: "sub mono voice" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.slotView(row, slot).ttsVoiceName
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("caneAudio.active"),
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type: row.isActive ? "success" : "info",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.isActive
                                ? _vm.$t("caneAudio.yes")
                                : _vm.$t("caneAudio.no")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("caneAudio.actions"),
              width: "260",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.openEditLanguage(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("caneAudio.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            _vm.openVersions(
                              "language",
                              row.code,
                              _vm.firstSlot(row)
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("caneAudio.versions")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.openUpload(
                              "language",
                              row.code,
                              _vm.firstSlot(row)
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("caneAudio.upload")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editingCode
              ? _vm.$t("caneAudio.editLanguageTitle", { code: _vm.editingCode })
              : _vm.$t("caneAudio.newLanguage"),
            visible: _vm.languageVisible,
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.languageVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "languageForm",
              attrs: {
                model: _vm.languageForm,
                rules: _vm.languageRules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("caneAudio.code"),
                            prop: "code",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: !!_vm.editingCode,
                              placeholder: "tr-TR",
                            },
                            model: {
                              value: _vm.languageForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "code", $$v)
                              },
                              expression: "languageForm.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("caneAudio.displayName"),
                            prop: "displayName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Turkish (Turkey)" },
                            model: {
                              value: _vm.languageForm.displayName,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "displayName", $$v)
                              },
                              expression: "languageForm.displayName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("caneAudio.backendKey"),
                            prop: "backendKey",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "tr-TR" },
                            model: {
                              value: _vm.languageForm.backendKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "backendKey", $$v)
                              },
                              expression: "languageForm.backendKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("caneAudio.otaFolder"),
                            prop: "otaFolder",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "TR" },
                            model: {
                              value: _vm.languageForm.otaFolder,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "otaFolder", $$v)
                              },
                              expression: "languageForm.otaFolder",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("caneAudio.manifestPrefix"),
                            prop: "manifestPrefix",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "tr" },
                            model: {
                              value: _vm.languageForm.manifestPrefix,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.languageForm,
                                  "manifestPrefix",
                                  $$v
                                )
                              },
                              expression: "languageForm.manifestPrefix",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("caneAudio.synthesisCode"),
                            prop: "synthesisCode",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "tr-TR" },
                            model: {
                              value: _vm.languageForm.synthesisCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "synthesisCode", $$v)
                              },
                              expression: "languageForm.synthesisCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("caneAudio.aliasesHelp") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "tr" },
                    model: {
                      value: _vm.languageForm.aliasesText,
                      callback: function ($$v) {
                        _vm.$set(_vm.languageForm, "aliasesText", $$v)
                      },
                      expression: "languageForm.aliasesText",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "form-section" }, [
                _vm._v(_vm._s(_vm.$t("caneAudio.voicesHelp"))),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                _vm._l(_vm.slotOrder, function (slot) {
                  return _c(
                    "el-col",
                    { key: slot, attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("caneAudio.slot_" + slot) } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("caneAudio.voicePlaceholder"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.languageForm.voices[slot],
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm.voices, slot, $$v)
                              },
                              expression: "languageForm.voices[slot]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("caneAudio.sortOrder") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, size: "small" },
                            model: {
                              value: _vm.languageForm.sortOrder,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "sortOrder", $$v)
                              },
                              expression: "languageForm.sortOrder",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("caneAudio.active") } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.languageForm.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.languageForm, "isActive", $$v)
                              },
                              expression: "languageForm.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.languageVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("caneAudio.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.saveLanguage },
                },
                [_vm._v(_vm._s(_vm.$t("caneAudio.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.versionsTitle,
            visible: _vm.versionsVisible,
            width: "900px",
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.versionsVisible = $event
            },
          },
        },
        [
          _vm.versionsCtx.kind === "language"
            ? _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchVersions },
                      model: {
                        value: _vm.versionsCtx.slot,
                        callback: function ($$v) {
                          _vm.$set(_vm.versionsCtx, "slot", $$v)
                        },
                        expression: "versionsCtx.slot",
                      },
                    },
                    _vm._l(_vm.slotOrder, function (slot) {
                      return _c("el-option", {
                        key: slot,
                        attrs: {
                          label: _vm.$t("caneAudio.slot_" + slot),
                          value: slot,
                        },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-upload2",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openUpload(
                            _vm.versionsCtx.kind,
                            _vm.versionsCtx.languageCode,
                            _vm.versionsCtx.slot
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("caneAudio.uploadVersion")) + " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.versionsLoading,
                  expression: "versionsLoading",
                },
              ],
              attrs: { data: _vm.versions, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("caneAudio.version"), width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "mono" }, [
                          _vm._v(_vm._s(row.version)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("caneAudio.size"), width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.fmtSize(row.size)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "sha256", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          { staticClass: "mono", attrs: { title: row.sha256 } },
                          [_vm._v(_vm._s(_vm.shortSha(row.sha256)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("caneAudio.uploadedAt"), width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(" " + _vm._s(_vm.fmtDate(row.createdAt)) + " "),
                        row.uploadedBy
                          ? _c("div", { staticClass: "sub mono" }, [
                              _vm._v(_vm._s(row.uploadedBy)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("caneAudio.note"), "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [_vm._v(_vm._s(row.note || "—"))]),
                        _c("el-button", {
                          attrs: {
                            type: "text",
                            size: "mini",
                            icon: "el-icon-edit",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.editNote(row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("caneAudio.active"),
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: row.isActive ? "success" : "info",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.isActive
                                  ? _vm.$t("caneAudio.yes")
                                  : _vm.$t("caneAudio.no")
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("caneAudio.actions"), width: "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        !row.isActive
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  loading: _vm.togglingId === row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setActive(row, true)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("caneAudio.activate")) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  plain: "",
                                  loading: _vm.togglingId === row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setActive(row, false)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("caneAudio.deactivate")) +
                                    " "
                                ),
                              ]
                            ),
                        _c(
                          "a",
                          {
                            staticClass: "dl",
                            attrs: {
                              href: row.url,
                              target: "_blank",
                              rel: "noopener",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-download" })]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sub", staticStyle: { "margin-top": "8px" } },
            [_vm._v(_vm._s(_vm.$t("caneAudio.versionsHint")))]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("caneAudio.uploadTitle"),
            visible: _vm.uploadVisible,
            width: "560px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("caneAudio.packKind") } },
                [
                  _c("el-input", {
                    attrs: { value: _vm.uploadKindLabel, disabled: "" },
                  }),
                ],
                1
              ),
              _vm.uploadForm.kind === "language"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("caneAudio.language") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.uploadForm.languageCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.uploadForm,
                                        "languageCode",
                                        $$v
                                      )
                                    },
                                    expression: "uploadForm.languageCode",
                                  },
                                },
                                _vm._l(_vm.languages, function (l) {
                                  return _c("el-option", {
                                    key: l.code,
                                    attrs: {
                                      label: l.code + " · " + l.displayName,
                                      value: l.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("caneAudio.voiceSlot") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.uploadForm.slot,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.uploadForm, "slot", $$v)
                                    },
                                    expression: "uploadForm.slot",
                                  },
                                },
                                _vm._l(_vm.slotOrder, function (slot) {
                                  return _c("el-option", {
                                    key: slot,
                                    attrs: {
                                      label: _vm.$t("caneAudio.slot_" + slot),
                                      value: slot,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("caneAudio.version") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "2026.11.01" },
                    model: {
                      value: _vm.uploadForm.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadForm, "version", $$v)
                      },
                      expression: "uploadForm.version",
                    },
                  }),
                  _c("div", { staticClass: "sub" }, [
                    _vm._v(_vm._s(_vm.$t("caneAudio.versionHelp"))),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("caneAudio.note") } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "500" },
                    model: {
                      value: _vm.uploadForm.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadForm, "note", $$v)
                      },
                      expression: "uploadForm.note",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("caneAudio.zipFile") } },
                [
                  _c("input", {
                    ref: "fileInput",
                    attrs: { type: "file", accept: ".zip,application/zip" },
                    on: { change: _vm.onFilePicked },
                  }),
                  _c("div", { staticClass: "sub" }, [
                    _vm._v(_vm._s(_vm.$t("caneAudio.zipHelp"))),
                  ]),
                ]
              ),
              _vm.uploadError
                ? _c(
                    "el-alert",
                    {
                      staticClass: "intro",
                      attrs: {
                        type: "error",
                        closable: false,
                        "show-icon": "",
                      },
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(_vm.$t("caneAudio.uploadRejected"))),
                      ]),
                      _c("div", { staticClass: "intro-body" }, [
                        _vm._v(_vm._s(_vm.uploadError)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.uploadVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("caneAudio.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.uploading,
                    disabled: !_vm.uploadReady,
                  },
                  on: { click: _vm.doUpload },
                },
                [_vm._v(" " + _vm._s(_vm.$t("caneAudio.upload")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }